import "../../pages/new/new.scss"
import React, { useRef, useEffect, useState, useMemo } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { getAllStudents, getBatches, getFilteredStudents } from '../../services/studentService';
import { getAllTerms } from '../../services/termService';
import { Link } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';
import axiosInstance from '../../api/axios';
import { toast } from 'react-toastify';


export const AssignTerm = () => {
    const navigate = useNavigate();
    const [students, setStudents] = useState([]);
    const [selectedStudents, setSelectedStudents] = useState([]);
    const [batches, setBatches] = useState([]);
    const [batchValue, setBatchValues] = useState();
    const [terms, setTerms] = useState([]);
    const [selectedTerm, setSelectedTerm] = useState(null);
    const [degrees, setDegrees] = useState([]);
    const [programs, setPrograms] = useState([]);
    const [selectedDegree, setSelectedDegree] = useState('');
    const [selectedProgram, setSelectedProgram] = useState('');
    const [batchHasEnrollments, setBatchHasEnrollments] = useState(true);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [errors, setErrors] = useState({});

    const fetchBatches = async () => {
        try {
            const batchdata = await getBatches();
          //  console.log(batchdata);
            setBatches(batchdata.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchFilteredStudents = async (batch, termId, degreeId, programId) => {
        try {
            const data = await getFilteredStudents(batch, termId, degreeId, programId);
            setStudents(data.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchTerms = async () => {
        try {
            const data = await getAllTerms();
          //  console.log(data);
            setTerms(data.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchDegreesAndPrograms = async () => {
        try {
            const [degreesRes, programsRes] = await Promise.all([
                axiosInstance.get('/getAllDegrees'),
                axiosInstance.get('/getAllPrograms'),
            ]);
            setDegrees(degreesRes.data?.data || []);
            setPrograms(programsRes.data?.data || []);
        } catch (err) {
            console.error('Error fetching degrees/programs:', err);
        }
    };
    useEffect(() => {
        fetchBatches();
        fetchTerms();
        fetchDegreesAndPrograms();
    }, []);
    const filteredPrograms = programs.filter(
        p => !selectedDegree || String(p.degreeId) === String(selectedDegree)
    );
    const checkBatchEnrollment = async (batch) => {
        if (!batch) return true;
        try {
            const response = await axiosInstance.get(`/batchHasEnrollments?batch=${batch}`);
            return !!response.data?.data;
        } catch (err) {
            return true;
        }
    };

    const handleBatchChange = async (event) => {
        const value = event.target.value;
        setBatchValues(value);
        const hasEnrollments = await checkBatchEnrollment(value);
        setBatchHasEnrollments(hasEnrollments);
        const degreeId = hasEnrollments ? selectedDegree : '';
        const programId = hasEnrollments ? selectedProgram : '';
        if (!hasEnrollments) {
            setSelectedDegree('');
            setSelectedProgram('');
        }
        fetchFilteredStudents(value, selectedTerm, degreeId, programId);
    };
    const handleStudentChange = (event) => {
        const selectedValues = Array.from(event.target.selectedOptions, option => option.value);
        setSelectedStudents(selectedValues);

    };

    // Selecting a term also applies the batch/degree/program it was tagged with
    // (AddTerm.jsx), so the student list doesn't stay stuck on whatever batch
    // filter happened to be selected before.
    const handleTermChange = async (event) => {
        const value = event.target.value;
        setSelectedTerm(value);

        const term = terms.find(t => String(t.id) === String(value));
        const batch = term?.batch || '';
        let degreeId = term?.degreeId || '';
        let programId = term?.programId || '';

        setBatchValues(batch);
        const hasEnrollments = await checkBatchEnrollment(batch);
        setBatchHasEnrollments(hasEnrollments);
        if (!hasEnrollments) {
            degreeId = '';
            programId = '';
        }
        setSelectedDegree(degreeId);
        setSelectedProgram(programId);

        fetchFilteredStudents(batch, value, degreeId, programId);
    };
    const handleDegreeChange = (event) => {
        const value = event.target.value;
        setSelectedDegree(value);
        setSelectedProgram('');
        fetchFilteredStudents(batchValue, selectedTerm, value, '');
    };
    const handleProgramChange = (event) => {
        const value = event.target.value;
        setSelectedProgram(value);
        fetchFilteredStudents(batchValue, selectedTerm, selectedDegree, value);
    };
    const validateForm = () => {
        const errors = {};
        if (!batchValue) {
            errors.batch = 'Batch is required';
        }
        if (!selectedTerm) {
            errors.term = 'Term is required';
        }
        if(!selectedStudents || selectedStudents.length === 0){
            errors.students='Select some students';
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        try {
            
           // console.log(selectedStudents);
          //  console.log(selectedTerm);
            var assignTerm = {
                studentEnrollmentNo: selectedStudents,
                termId: selectedTerm
            }
            var response = await axiosInstance.post('/assignStudentTerm', assignTerm,{showToastOnResponse: true});
            navigate('/');
            
        } catch (error) {
            console.log('Error saving termcourse. Please try again later.');
            console.log(error);
        }
    };
    const goBack = (e) => {
        navigate('/');
    };
    return (
        <div>
            <div className="top">
                <h1>{'Assigned Student Terms'}</h1>
            </div>
            <div className="bottom">
                <div className="left"></div>
                <div className="right">
                    <form onSubmit={handleSubmit}>
                        <div className="formInput">
                            <label>Select Batch </label>
                            <select id="styled-dropdown"
                                name="batch"
                                value={batchValue}
                                onChange={handleBatchChange}
                            >
                                <option value="">All Batches</option>
                                {batches && batches.map(option => (
                                    <option key={option} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                            {errors.batch && <div className="error-text">{errors.batch}</div>}
                        </div>

                        <div className="formInput">
                            <label>Select Term </label>
                            <select id="styled-dropdown"
                                name="term"
                                value={selectedTerm}
                                onChange={handleTermChange}
                            >
                                <option value="">All Terms</option>
                                {terms && terms.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.name}
                                    </option>
                                ))}
                            </select>
                            {errors.term && <div className="error-text">{errors.term}</div>}
                        </div>
                        <div className="formInput">
                            <label>Select Degree </label>
                            <select id="styled-dropdown"
                                name="degreeId"
                                value={selectedDegree}
                                onChange={handleDegreeChange}
                                disabled={!batchHasEnrollments}
                            >
                                <option value="">All Degrees</option>
                                {degrees && degrees.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.degreeName}
                                    </option>
                                ))}
                            </select>
                            {!batchHasEnrollments && <div className="error-text">This batch has no degree/program enrollment data</div>}
                        </div>
                        <div className="formInput">
                            <label>Select Program </label>
                            <select id="styled-dropdown"
                                name="programId"
                                value={selectedProgram}
                                onChange={handleProgramChange}
                                disabled={!batchHasEnrollments}
                            >
                                <option value="">All Programs</option>
                                {filteredPrograms.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.programName}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="formInput" style={{ width: '100%' }}>
                            <label>Select Students </label>
                            <select id="styled-dropdown"
                                name="students"
                                multiple
                                value={selectedStudents}
                                onChange={handleStudentChange}
                                style={{ height: '420px' }}
                            >

                                {students && students.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.enrollmentNumber} : {option.name}
                                        {option.currentPhase ? ` — ${option.currentPhase}` : ''}
                                        {option.currentStatus ? ` (${option.currentStatus})` : ''}
                                    </option>
                                ))}
                            </select>
                            {errors.students && <div className="error-text">{errors.students}</div>}
                        </div>
                        <div className="buttons">
           <button type="submit">{'Save'}</button>
           <button onClick={goBack}>Back</button>
           </div>
                    </form>
                </div>
            </div>
        </div>
    );
};


